<ws-modal-wrapper headerLabel="Complete File Appeal Tasks"
                  acceptLabel="Process"
                  [disableSave]="loading"
                  [disableCancel]="loading"
                  [loading]="loading"
                  (save)="process()"
                  (cancel)="cancel()">
    <div style="height: 70px;">
        <label>
            <span>Filing Reference #:</span>
            <input type="text"
                   class="ms-2"
                   [(ngModel)]="payload.filingReference"
                   maxlength="50"
                   [disabled]="loading"/>
        </label>
    </div>
</ws-modal-wrapper>
